export enum Lang {
  EN = 'en',
  AZ = 'az',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  NL = 'nl',
  PL = 'pl',
  RU = 'ru',
  TR = 'tr',
  UA = 'uk',
  VT = 'vi',
}

export const ActiveLanguages = [
  Lang.EN,
  Lang.UA,
  Lang.PL,
  Lang.TR,
  Lang.ES,
  Lang.FR,
  Lang.NL,
  Lang.VT,
  Lang.RU,
  Lang.AZ,
  Lang.DE,
];
